import { useIntl } from 'react-intl'
import { PrimitiveType, FormatXMLElementFn } from 'intl-messageformat'
import { MessageFormatElement } from '@formatjs/icu-messageformat-parser'
import en from '../locales/en.json'
import { flatten } from '../helpers/objects'
import { ReactNode } from 'react'

const defaultTranslation: Record<
  string,
  string | MessageFormatElement[]
> = flatten(en)

export default function useTranslation() {
  const { formatMessage: m } = useIntl()

  function formatMessage(
    descriptor: Parameters<typeof m>[0],
    values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>,
  ): string

  function formatMessage(
    descriptor: Parameters<typeof m>[0],
    values?: Record<string, PrimitiveType | FormatXMLElementFn<any, any>>,
  ): ReactNode

  function formatMessage(descriptor: any, values?: any) {
    const id: string = descriptor.id as string
    return m({ ...descriptor, defaultMessage: defaultTranslation[id] }, values)
  }

  return { formatMessage }
}
